import React, { useState, useEffect, useCallback } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { getLeadAccounts, getUsers } from '../api';
import { isAdmin, isPropietario, isGestion, isEspectador, getUserId } from '../services/AuthService';

const LeadAccountDailyStatsSearchForm = ({ onSearch, leadAccounts = [] }) => {
    const currentUserId = getUserId();
    const isSuperUser = isAdmin() || isPropietario() || isGestion() || isEspectador();
    
    const [filters, setFilters] = useState({
        leadAccountId: '',
        assignedLeadId: isSuperUser ? '' : currentUserId || '',
        statDateFrom: new Date().toISOString().split('T')[0],
        statDateTo: new Date().toISOString().split('T')[0]
    });
    const [leadUsers, setLeadUsers] = useState([]);

    useEffect(() => {
        loadLeadUsers();
    }, []);

    const loadLeadUsers = async () => {
        try {
            const response = await getUsers(false);
            const leads = response.filter(user => 
                user.roles && user.roles.some(role => role.name === 'Leads')
            );
            setLeadUsers(leads);
        } catch (error) {
            console.error('Error loading lead users:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newFilters = {
            ...filters,
            [name]: value
        };
        setFilters(newFilters);
        
        // Búsqueda inmediata
        const searchFilters = {};
        if (newFilters.leadAccountId) searchFilters.leadAccountId = newFilters.leadAccountId;
        if (newFilters.assignedLeadId) searchFilters.assignedLeadId = newFilters.assignedLeadId;
        if (newFilters.statDateFrom) searchFilters.statDateFrom = newFilters.statDateFrom;
        if (newFilters.statDateTo) searchFilters.statDateTo = newFilters.statDateTo;
        onSearch(searchFilters);
    };

    const handleClear = () => {
        const today = new Date().toISOString().split('T')[0];
        setFilters({
            leadAccountId: '',
            assignedLeadId: isSuperUser ? '' : currentUserId || '',
            statDateFrom: today,
            statDateTo: today
        });
    };

    return (
        <div className="mb-3" data-testid="search-form-container">
            <Row>
                <Col md={isSuperUser ? 3 : 4}>
                    <Form.Group>
                        <Form.Label>Cuenta de Lead</Form.Label>
                        <Form.Select
                            name="leadAccountId"
                            value={filters.leadAccountId}
                            onChange={handleInputChange}
                            data-testid="lead-account-selector"
                        >
                            <option value="">Todas</option>
                            {leadAccounts.map(account => (
                                <option key={account.id} value={account.id}>
                                    {account.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
                {isSuperUser && (
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Lead Asignado</Form.Label>
                            <Form.Select
                                name="assignedLeadId"
                                value={filters.assignedLeadId}
                                onChange={handleInputChange}
                                data-testid="assigned-lead-selector"
                            >
                                <option value="">Todos</option>
                                {leadUsers.map(user => (
                                    <option key={user.id} value={user.id}>
                                        {user.username}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                )}
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Fecha Desde</Form.Label>
                        <Form.Control
                            type="date"
                            name="statDateFrom"
                            value={filters.statDateFrom}
                            onChange={handleInputChange}
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            data-testid="date-from-picker"
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Fecha Hasta</Form.Label>
                        <Form.Control
                            type="date"
                            name="statDateTo"
                            value={filters.statDateTo}
                            onChange={handleInputChange}
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            data-testid="date-to-picker"
                        />
                    </Form.Group>
                </Col>
                <Col md={2} className="d-flex align-items-end">
                    <Button type="button" variant="secondary" onClick={handleClear} data-testid="clear-filters-button">
                        Limpiar
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default LeadAccountDailyStatsSearchForm;